import { flatten } from 'lodash';
import { App } from '@gin-betting/core';

// Prevent circular dependency
import type { ExtendedRouts } from 'types';
import removeLastSlash from './removeLastSlash';

export default function getExtraMatchListRoutes(
    routs: typeof ExtendedRouts
): string[] {
    // Attention sync with InnerRouts

    return [
        routs.UPCOMING_LIST,
        routs.OUTRIGHTS_LIST,
        routs.RESULTS_LIST,
        routs.LIVE_LIST,
        routs.PREMATCH,
        routs.CLASSIC,
        routs.ESPORT,
        routs.TOURNAMENT,
        ...flatten([routs.CLASSIC, routs.ESPORT].map(makeExtraMatchListRoutes)),
    ].map(removeLastSlash);

    function makeExtraMatchListRoutes(
        parentRoute: App.Routes.CLASSIC | App.Routes.ESPORT
    ): string[] {
        // Attention sync with InnerRouts
        return [
            routs.LIVE_LIST,
            routs.OUTRIGHTS_LIST,
            routs.RESULTS_LIST,
            routs.PREMATCH,
            routs.TOURNAMENT,
        ].map(route => `${parentRoute}${route}`);
    }
}
